export enum Icons {
  ACCOUNT = 'account',
  ADDITION_SIGN = 'addition-sign',
  ARROW_DOWN = 'arrow-down',
  ARROW_LEFT = 'arrow-left',
  ARROW_RIGHT = 'arrow-right',
  BELL = 'bell',
  BELL_MARKED = 'bell-marked',
  BLACK_ARROW_RIGHT = 'black-arrow-right',
  BLACK_INFO = 'black-info',
  BLUE_INFO = 'blue-info',
  BLACK_LOGO = 'black-logo',
  CALENDAR = 'calendar',
  CHEVRON_DOWN = 'chevron-down',
  CHEVRON_LEFT = 'chevron-left',
  CHEVRON_RIGHT = 'chevron-right',
  CIRCLE_LOADING = 'circle-loading',
  CLOSE = 'x-close',
  CLOSE_CIRCLE = 'close',
  COPY = 'copy',
  CROSS = 'cross',
  DOTTED_CIRCLE = 'dotted-circle',
  DOWNLOAD = 'download',
  DOWNLOAD_ARROW_SIGN = 'download-arrow-sign',
  EDIT = 'edit',
  EDIT_WHITE = 'edit-white',
  ERROR = 'error',
  FILLED_ERROR = 'filled-error',
  EYE_CLOSED = 'eye-closed',
  EYE_OPEN = 'eye-open',
  GEAR = 'gear',
  GREEN_GLITTER = 'green-glitter',
  INFO = 'info',
  LOADING = 'loading',
  PLAY = 'play',
  PLUS = 'plus',
  QUESTION_MARK = 'question-mark',
  REQUIRED = 'required',
  SEARCH = 'search',
  SUBTRACT_SIGN = 'subtract-sign',
  SUCCESS = 'success',
  SWISS_FLAG = 'swiss-flag',
  TRANSPARENT_INFO_ICON = 'transparent-info-icon',
  TRASH = 'trash',
  TRIANGLE_WARNING = 'triangle-warning',
  UPLOAD = 'upload',
  VOLUME_MUTED = 'volume-muted',
  VOLUME_ON = 'volume-on',
  WARNING = 'warning',
  WHITE_DELETE = 'white-delete',
  WHITE_LOGO = 'white-logo',
  XLSX_FILE = 'xlsx-file',
}

export type IconValues = `${Icons}`;
